import React, { forwardRef } from 'react';

import { ChevronDownFill } from '@lyearn/icons';
import { cn } from '@lyearn/style';
import { usePopoverContext } from '@lyearn/ui';
import AddMoreButton from '@/components/FilterManager/components/AddMoreButton/AddMoreButton';
import { AppliedFilterItemAppearance } from '@/components/FilterManager/EntityFilterManager/types';

import ActionButton from '../ActionButton';
import { addMoreButtonOverrideStyles } from './styles';

interface Props {
  children?: string | React.ReactNode;
  isSelected?: boolean;
  endIcon?: React.ReactNode;
  startIcon?: React.ReactNode;
  id?: string;
  className?: string;
  onClick?: () => void;
  appearance?: AppliedFilterItemAppearance;
}

const MenuActionButton = forwardRef<HTMLButtonElement, Props>((props, ref) => {
  const { children, appearance, className, ...rest } = props;
  // TODO: since we are using children in suspense fallback, we need to pass showError: false to the popover
  const popover = usePopoverContext({ showError: false });
  const isOpen = popover?.open;

  if (appearance === 'primary') {
    return (
      <AddMoreButton
        ref={ref}
        {...rest}
        className={cn(className, addMoreButtonOverrideStyles)}
        endIcon={<ChevronDownFill className="arrow-icon" fillColorToken="icon-secondary" />}
        isOpen={isOpen}
        isSelected={false}>
        {children}
      </AddMoreButton>
    );
  }

  return (
    <ActionButton ref={ref} isOpen={isOpen} {...rest}>
      {children}
    </ActionButton>
  );
});

export default MenuActionButton;
